<template>
  <div class="max-width-container">
    <h1>Ketchup showcase</h1>

    <h2>About Ketchup</h2>
    <p>
      Ketchup is a
      <a href="https://www.webcomponents.org/" target="_blank" rel="noopener"
        >web components</a
      >
      library, built with
      <a href="https://stenciljs.com/" target="_blank" rel="noopener"
        >Ionic's Stencil</a
      >, a small TypeScript based web component compiler.
    </p>
    <p
      >The primary focus of Ketchup consists in providing a suite of powerful
      and customizable web components, whose main objective is abstracting
      complex, yet very recurrent, programming patterns.</p
    >
    <p>
      Inside
      <a
        href="https://github.com/smeup/ketchup/tree/develop/packages/ketchup/src/components"
        target="_blank"
        rel="noopener"
        >Ketchup repo</a
      >
      you can find all the documentation concerning these components. <br />You
      can install the Ketchup library using npm, check
      <a
        href="https://www.npmjs.com/package/@sme.up/ketchup"
        target="_blank"
        rel="noopener"
        >this</a
      >
      link for more information.
    </p>

    <h3>Credits</h3>
    <p>
      This showcase was built using
      <a href="https://vuejs.org/" target="_blank" rel="noopener">Vue.js</a>.
    </p>
  </div>
</template>

<script>
export default {
  name: 'home',
  title: 'Ketchup | Showcase',
};
</script>
